export default "__VITE_ASSET__hxcDXG3t__"